import { render, staticRenderFns } from "./BacklogByLocation.vue?vue&type=template&id=3f95c4ac&scoped=true&"
import script from "./BacklogByLocation.vue?vue&type=script&lang=js&"
export * from "./BacklogByLocation.vue?vue&type=script&lang=js&"
import style0 from "./BacklogByLocation.vue?vue&type=style&index=0&id=3f95c4ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f95c4ac",
  null
  
)

export default component.exports